export default {
  "content": "<path d=\"M176 48h160M118 304h276M208 48v93.48a64.09 64.09 0 01-9.88 34.18L73.21 373.49C48.4 412.78 76.63 464 123.08 464h265.84c46.45 0 74.68-51.22 49.87-90.51L313.87 175.66a64.09 64.09 0 01-9.87-34.18V48\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};